import { styled, Typography } from 'opensolar-ui'
import { useMemo, useState } from 'react'
import { useTranslate } from 'react-admin'

const StyeledTypography = styled(Typography)({
  color: '#0094FF',
  margin: '10px',
  fontWeight: 400,
  cursor: 'pointer',
})

const useLimitedOptionsController = <T,>(options: T[], limit = 4) => {
  const [showMore, setShowMore] = useState(false)
  const translate = useTranslate()
  const handleShowMore = () => {
    setShowMore(true)
  }

  const handleShowLess = () => {
    setShowMore(false)
  }

  const LimitedOptionsController = useMemo(() => {
    if (options.length <= limit) {
      return null
    }
    if (showMore === false) {
      return <StyeledTypography onClick={handleShowMore}>{translate('Show more')}</StyeledTypography>
    } else {
      return <StyeledTypography onClick={handleShowLess}>{translate('Show less')}</StyeledTypography>
    }
  }, [options, showMore])

  const limitedOptions = useMemo(() => {
    if (showMore) {
      return options
    }

    return options.slice(0, limit)
  }, [showMore, options, limit])

  return {
    limitedOptions,
    LimitedOptionsController,
  }
}

export default useLimitedOptionsController
